import { CellValue, Row } from 'react-table';

import { summarizeRowsAbove } from '../constants';
import { getGapForRows } from '.';

/**
 * Aggregates columns into a single gap value.
 */
export const aggregateGap = (
    leafValues: CellValue<Row<TrqkGapChannelAudio>>[],
): number => {
    if (leafValues.length < summarizeRowsAbove) {
        // This case never seems to happen, probably because the aggregation function is never
        // called with an empty leafValues array, but we handle it just in case.
        return 0;
    }

    return getGapForRows(leafValues);
};
